<template>
   <div class="uk-grid-medium uk-child-width-1-5@m uk-grid-small uk-grid-match tm-margin-large-top uk-text-center" data-uk-grid>
    <template v-for="one in modules">
    <div v-if="permissions[one.slug] == true || permissions['group_name'] == 'admin'"  :key="one.id">
           <a :href="one.url" target="_blank" class="uk-card uk-card-box uk-card-body uk-border-rounded">
               <span class="uk-icon-forder uk-border-rounded"><span :data-uk-icon="'icon: '+one.icon+'; ratio: 2'"></span></span>
               <p>{{one.title}}</p>
           </a>
     </div>
     </template>
   </div>
</template>

<script>
export default {
      props:{
        permissions:{
            type:Object
        },
        modules:{}
      }
}
</script>